import Seo, { faqSchema } from "@/components/Seo";
import Hero from "@/components/sections/Hero";
import {
  WhatIsGeo, WhyGeo, WhatWeDo, Platforms, ServicesGrid,
  WhyChoose, Process, IndustriesGrid, CaseStudies, Testimonials, HomeFaqs,
} from "@/components/sections/HomeSections";
import CtaSection from "@/components/shared/CtaSection";
import { HOME_FAQS } from "@/data/faqs";

export default function Home() {
  return (
    <>
      <Seo
        title="Generative Engine Optimization (GEO) Consulting Company"
        description="CompuBrain AI is India's leading Generative Engine Optimization (GEO) consulting company. We help businesses get discovered, trusted and recommended by ChatGPT, Gemini, Claude, Perplexity and AI search engines. 5300+ clients, 20+ years."
        path="/"
        schemas={[faqSchema(HOME_FAQS.slice(0, 10))]}
      />
      <Hero />
      <WhatIsGeo />
      <WhyGeo />
      <WhatWeDo />
      <Platforms />
      <ServicesGrid />
      <WhyChoose />
      <Process />
      <IndustriesGrid />
      <CaseStudies />
      <Testimonials />
      <HomeFaqs />
      <CtaSection />
    </>
  );
}
